import { FieldArray, useFormikContext } from 'formik'
import { useParams } from 'react-router-dom'
import { RotateCcw } from 'lucide-react'
import React, { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import requests from 'service/api'
import { useOrderPriceSave, useOrderPriceUpdate } from 'store/server/useOrder'
import DisliSayisiDetayModal from 'components/form/modals/DisliSayisiDetayModal'

import { Input } from 'components/form/input'
import { Input as NoFormInput } from 'components/ui/input'
import { Button } from 'components/ui/button'
import { Separator } from 'components/ui/separator'
import { SelectReferanceCode3 } from 'components/form/compobox/select-referance-code3'
import { toast } from 'components/ui/use-toast'
import PriceSizes from '../PriceInstructions/PriceSize'
import PriceSizesHome from './PriceSize/pricehome'
import PriceSection from '../PriceInstructions/PriceSection'
import PriceSectionHome from './PriceSection/indexhome'
import { Form, Input as AntInput, Button as AntButton, Select, message, Modal, Table,Tooltip  } from 'antd'
import { Button as UIButton } from 'components/ui/button';

import { RxCross1 } from "react-icons/rx";
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { useAuth } from 'store/client/authStore'
import Symbol from './PriceSize/PrimeHomeWashing/Symbol'
const { Option } = Select

export default function PriceInstructions({ currentTab,brannd,deptName }) {
  const { values, setFieldValue } = useFormikContext()
  const { mutate: saveOrder, isPending } = useOrderPriceSave()
  const { mutate: updateOrder, isPending: isPendingUpdate } = useOrderPriceUpdate()
  const { brand, orderNo, dept, subDept } = useParams()
  const brandId = brand.split('_')[0]
  const [isDisliModalVisible, setIsDisliModalVisible] = useState(false)
  const [isBicakIziModalVisible, setIsBicakIziModalVisible] = useState(false)
  const [sizeAmounts, setSizeAmounts] = useState({})
  const [totalAmount, setTotalAmount] = useState(0)
  const [mottoTake, setMottoTake] = useState(20)
  const [homeProducts, setHomeProducts] = useState([])
  const [departmantIDD, setdepartmantIDD] = useState('')
  const [ifinch,setifinch] = useState(false)
  const { user } = useAuth()
  const isHome = brannd === "ZaraHome"

  const deriveMixFromSizes = (priceLabelItem) => {
    const sizes = priceLabelItem?.sizes || []
    const mixedByIndex = [0,1,2,3].map((mixIdx) => {
      // İlk dolu olan bedenin ilgili mix indeksini al
      const found = sizes.find(sz => sz?.mixed?.[mixIdx]?.currency)
      if (found && found.mixed && found.mixed[mixIdx]) {
        return {
          currency: String(found.mixed[mixIdx].currency || ''),
          type: found.mixed[mixIdx].currencyType || undefined,
        }
      }
      return { currency: '', type: undefined }
    })
    return mixedByIndex
  }
  const handleSaveOrUpdateOrder = () => {
    // Hata mesajlarını saklamak için bir dizi
    const errors = [];
  
    // currency1 ve currency2 için boş olup olmadığını kontrol et
    values.priceLabel.forEach((item, index) => {
      if (!item.mix[0]?.currency) {
        errors.push(`Price Label ${index + 1}: Currency 1 alanı boş olamaz.`);
      }
      if (!item.mix[1]?.currency) {
        errors.push(`Price Label ${index + 1}: Currency 2 alanı boş olamaz.`);
      }
    });
  
    // Hata varsa, işlemi durdur ve hataları göster
    if (errors.length > 0) {
      // Hataları gösterme şeklinizi buraya yazın. Örneğin:
      alert(errors.join('\n'));
      return; // İşlemi durdur
    }
  }


  useEffect(() => {
    const fetchHomeProducts = async () => {
      if (brannd === "ZaraHome") {

  
        try {
          const response = await requests.homeproducts.list();
          setHomeProducts(response.data.products);

        } catch (error) {
          console.error("Ürünler çekilirken hata oluştu", error);
        }
      }
    };
  
    fetchHomeProducts();
  }, [brannd]);
  


useEffect(() => {
  if(dept === "657c420ed3e9e8e6f1b83add_Kids"){
  setMottoTake(24)
}
}, [dept])
  const handleDisliModalClose = () => {
    setIsDisliModalVisible(false)
  }

  const handleDisliModalOpen = () => {
    setIsDisliModalVisible(true)
  }

  const handleBicakIziModalOpen = () => {
    // Tüm bedenler için sıfırlama işlemi
    const initialSizeAmounts = {};
    
    // Sadece seçilmiş bedenleri göster (adet değeri girilmiş olanlar)
    const selectedSizes = values.priceLabel[0]?.sizes.filter(size => 
      size.amount && size.amount !== '0' && size.amount !== 0
    );
    // Her beden için değeri açıkça 0 olarak ayarla
    selectedSizes.forEach(size => {
      // Beden kodu+beden adı birleşik key oluşturuyoruz
      const key = `${size.sCode}_${size.name || 'Beden'}`;
      initialSizeAmounts[key] = 0;
    });
    
    // State'i güncelle
    setSizeAmounts(initialSizeAmounts);
    setTotalAmount(0);
    setIsBicakIziModalVisible(true);
  };

  const handleBicakIziModalClose = () => {
    setIsBicakIziModalVisible(false)
  }

  const handleSizeAmountChange = (sizeCode, sizeName, value) => {
    // Birleşik key oluştur
    const key = `${sizeCode}_${sizeName || 'Beden'}`;
    
    // Girilen değeri sayıya çevir (boş ise 0)
    const numValue = value === '' ? 0 : parseInt(value, 10);
    
    // Diğer tüm bedenlerin toplamını hesapla
    let otherSizesTotal = 0;
    Object.entries(sizeAmounts).forEach(([existingKey, amount]) => {
      if (existingKey !== key) {
        otherSizesTotal += amount;
      }
    });
    
    // Toplam adet kontrolü
    if (otherSizesTotal + numValue > mottoTake) {
      // 20'yi aşıyorsa, maksimum izin verilen değeri hesapla
      const maxAllowed = mottoTake - otherSizesTotal;
      
      // Eğer maksimum değer 0'dan küçükse, hiç değer girilmesine izin verme
      if (maxAllowed <= 0) {
        toast.error("Toplam adet 20'yi geçemez!");                              
        return;
      }
      
      // Değeri güncelle - Sadece ilgili beden key'i değişecek
      const updatedAmounts = { ...sizeAmounts };
      updatedAmounts[key] = maxAllowed;
      setSizeAmounts(updatedAmounts);
      
      // Yeni toplam
      const newTotal = Object.values(updatedAmounts).reduce((sum, val) => sum + val, 0);
      setTotalAmount(newTotal);
      return;
    }
    
    // Normal durumda değeri güncelle - Sadece ilgili beden key'i değişecek
    const updatedAmounts = { ...sizeAmounts };
    updatedAmounts[key] = numValue;
    setSizeAmounts(updatedAmounts);
    
    // Yeni toplam
    const newTotal = Object.values(updatedAmounts).reduce((sum, val) => sum + val, 0);
    setTotalAmount(newTotal);
  };

  const handleBicakIziBas = () => {
    // İşlem tamamlandıktan sonra modalı kapat
    setIsBicakIziModalVisible(false)
    // Başarılı mesajı göster
    toast.success('Bıçak izi hazırlama işlemi başarıyla tamamlandı')
  }

  // URL parametreleri oluşturan yardımcı fonksiyon
  const createBicakIziUrl = () => {
    // Temel URL ve tab parametresi
    
    let url = `/siparisler/artwork/${orderNo}?tab=2&gottype=man`;
    if(brannd === "ZaraHome"){
      url = `/siparisler/artwork/${orderNo}?tab=2&gottype=man&zaratype=ZaraHome`;
    }
    
    // Beden ve adet bilgilerini ekle
    let paramIndex = 0;
    
    // Size mappings oluştur (sizeCode => {sizeName, count})
    const sizeMappings = {};
    
    // Önce tüm size code ve name eşleşmelerini al
    values.priceLabel[0]?.sizes
      .filter(size => size.amount && size.amount !== '0' && size.amount !== 0)
      .forEach(size => {
        const sizeName =  size.name || size.sizeCode;
        const key = `${size.sCode}_${sizeName}`;

        if (sizeAmounts[key] > 0) {
          sizeMappings[paramIndex] = {
            sizeCode: size.sCode,
            sizeName: sizeName,
            count: sizeAmounts[key]
          };
          paramIndex++;
        }
      });
    
    // URL parametrelerini ekle
    Object.entries(sizeMappings).forEach(([index, sizeInfo]) => {
      url += `&sizecode${index}=${encodeURIComponent(sizeInfo.sizeCode)}`;
      url += `&sizename${index}=${encodeURIComponent(sizeInfo.sizeName)}`;
      url += `&count${index}=${sizeInfo.count}`;
    });
    
    // Toplam parametre sayısını da ekle
    url += `&totalParams=${paramIndex}`;
 
    return url;
  };

  const ClearableSelect = ({ value, onChange, options, placeholder, form, name }) => {
    const handleClear = () => {
      // Seçili değeri sıfırla
      form.setFieldsValue({ [name]: undefined });
      onChange(undefined);
    };
  
    return (
      <div style={{ position: "relative" }}>
  
        <Select
          showSearch
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{ width: '100%' }}
          filterOption={(input, option) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
          suffixIcon={<span style={{ display: 'none' }}></span>} // Arama ikonunu gizler
  
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        {value && (
          <RxCross1
            onClick={handleClear}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "red",
            }}
          />
        )}
      </div>
    );
  };
  const DrawerContent4 = () => {
    const [form4] = Form.useForm()
    const [GrafDurum, setGrafDurum] = useState([]) // Tablo verileri için state
    const [GrafDurumOld, setGrafDurumOld] = useState([]) // Tablo verileri için state
    const [searchText, setSearchText] = useState('') // Tablo verileri için state
    const [isRowModalVisible, setIsRowModalVisible] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null); // Seçilen satırdaki veri
    const [colordsx, setcolordsx] = useState([
      { code: "W", text: " WHITE" },
      { code: "B", text: "BLACK" },
    ]);
  const isZaraHome = brannd === 'ZaraHome'
  const LABEL_CATEGORY = isZaraHome ? 'LABEL9 KARTI' : 'FİYAT KARTI'
    // React Query ile veri çekimi
    const { data, isFetched, refetch } = useQuery({
      queryKey: ['/list', 'referance'],
      queryFn: async () => {
        const { data } = await requests.referance.list()

        return data
      },
      placeholderData: []
    })

    // useEffect ile her girişte veri yeniden çekilsin
    useEffect(() => {
      if (data && data.length > 0) {
        const isWasgingLabel = data.filter(
          (item) => item.labelCategory === LABEL_CATEGORY
        )

        setGrafDurum(isWasgingLabel)
        setGrafDurumOld(isWasgingLabel)
      }
    }, [data, LABEL_CATEGORY])



    // Uyarı etiketleri için filtreleme

    const onSipNoFinishGrafik = (values) => {
      const requiredFields = ['code', 'name', 'height','width', 'kod', 'a', 'backgroundColor'];
      const emptyFields = requiredFields.filter((field) => !values[field]);

      // Eğer boş alan varsa hata döndür
      if (emptyFields.length > 0) {
        const fieldNames = {
          code: 'Kod',
          name: 'İsim',
          height: 'Yükseklik',
          width:'Genişlik',
          kod: 'Kod',
          a: 'A Değeri',
          backgroundColor: 'Arkaplan Rengi',
        };
        const missingFields = emptyFields.map((field) => fieldNames[field]).join(', ');
        message.error(`Lütfen şu alanları doldurun: ${missingFields}`);
        return; // Devam etme
      }
      
      Modal.confirm({
        title: 'Referans eklemek istiyor musunuz?',
        content: 'Evet dediğinizde Referans bilgileri eklenecektir.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.addReferenceCode({
              code: values.code,
              name: values.name,
              height: values.height,
              width:values.width,
              subDepartmentId: "6575fe53f5358ec4a7a0d0b8",
              kod: values.kod,
              labelCategory: LABEL_CATEGORY,
              labelType: LABEL_CATEGORY,
              a: values.a,
              backgroundColor: values.backgroundColor,
              shape: '',
              shape2: ''
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })
              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle
            }

          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
        }
      })
    }
    const handleReferanceSil = (id) => {
      Modal.confirm({
        title: 'Referansı silmek güncellemek istiyor musunuz?',
        content: 'Referans silindiğinde geri alınmayacaktır.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.deleteReferenceCode({
              id: id,
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })

              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle

            }
          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
        }
      })
    };
  
    const handleSearchmini = (value) => {
      setSearchText(value);
      const filtered = GrafDurum.filter((item) => {
        return (
          (item.code && item.code.includes(value)) || // code zaten string
          (item.height && String(item.height).includes(value)) || // height string'e dönüştürülüyor
          (item.width && String(item.width).includes(value)) || // width string'e dönüştürülüyor
          (item.name && item.name.includes(value)) // name zaten string
        );
      });
      setGrafDurum(value ? filtered : GrafDurumOld);
      
  
    };
    const minicolumnsgrafikdurum = [
      {
        title: 'Kod',
        dataIndex: 'code',
        key: 'code',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'İsim',
        dataIndex: 'name',
        key: 'name',
        render: (text) => (
          <Tooltip title={text}>
            <span style={{ fontSize: '12px' }}>
              {text.length > 20 ? `${text.substring(0, 20)}...` : text}
            </span>
          </Tooltip>
        ),

      },
      {
        title: 'Width',
        dataIndex: 'width',
        key: 'width',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Height',
        dataIndex: 'height',
        key: 'height',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Renk',
        dataIndex: 'backgroundColor',
        key: 'backgroundColor',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Açıklamakod',
        dataIndex: 'kod',
        key: 'kod',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      }, // Fazladan virgül bu satırdan kaldırıldı
      {
        title: 'İşlemler',
        key: 'actions',
        render: (text, record) => (
          <div
          onClick={(e) => {
        e.stopPropagation(); // Tıklama olayını üst katmanlara taşımayı engeller
        handleReferanceSil(record.id); // Silme işlemini tetikler
      }}
          style={{
            cursor: 'pointer', // Tıklanabilir hissiyatı verir
            padding: '5px 10px',
            backgroundColor: 'red',
            color: 'white',
            border: '1px solid red',
            borderRadius: '4px',
            display: 'inline-block',
            textAlign: 'center',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#cc0000'; // Hover rengi
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'red'; // Orijinal renk
          }}
        >
          Referans Sil
        </div>
        ),
      },
    ];
    const handleRowGrafDurumClick = (record) => {
      setSelectedRowData(record); // Satırdaki veriyi state'e aktar
      setIsRowModalVisible(true); // Modalı aç
    };

    const handleRowModalSave = () => {
      // Kaydetme işlemleri burada yapılır
 
      const requiredFields = ['code', 'name', 'height','width', 'kod', 'a', 'backgroundColor'];
      const emptyFields = requiredFields.filter((field) => !selectedRowData[field]);

      // Eğer boş alan varsa hata döndür
      if (emptyFields.length > 0) {
        const fieldNames = {
          code: 'Kod',
          name: 'İsim',
          height: 'Yükseklik',
          width:'Genişlik',
          kod: 'Kod',
          a: 'A Değeri',
          backgroundColor: 'Arkaplan Rengi',
        };
        const missingFields = emptyFields.map((field) => fieldNames[field]).join(', ');
        //message.error(`Lütfen şu alanları doldurun: ${missingFields}`);
        return; // Devam etme
      }
      Modal.confirm({
        title: 'Referans durumunu güncellemek istiyor musunuz?',
        content: 'Evet dediğinizde Referans bilgileri güncellenecektir.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.updateReferenceCode({
              id:selectedRowData.id,
              code: selectedRowData.code,
              name: selectedRowData.name,
              height: selectedRowData.height,
              width:selectedRowData.width,
              subDepartmentId: "6575fe53f5358ec4a7a0d0b8",
              kod: selectedRowData.kod,
              labelCategory: LABEL_CATEGORY,
              labelType: LABEL_CATEGORY,
              a: selectedRowData.a,
              backgroundColor: selectedRowData.backgroundColor,
              shape: '',
              shape2: ''
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })
              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle

            }
          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
        }
      })
      // Örneğin, updateOrder fonksiyonuna gönderilebilir:

    
      setIsRowModalVisible(false); // Modalı kapat
    };
    
    const handleRowModalChange = (key, value) => {
      setSelectedRowData((prev) => ({ ...prev, [key]: value })); // Seçilen veriyi güncelle
    };
    return (
      <div>
        <Form
          form={form4}
          layout="horizontal"
          onFinish={onSipNoFinishGrafik}
          initialValues={{ radio: '1' }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            position: 'relative',
            flexShrink: 1,
            boxSizing: 'border-box',
            overflow: 'hidden',
            width: 700
          }}
          labelAlign="left"
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: '16px',
              width: '100%'
            }}
          >
            <Form.Item label="Kod:" name="code" style={{ width:"100%",margin:0,padding:0 }}>
              <AntInput placeholder="Kod girin" />
            </Form.Item>
            <Form.Item label="İsim:" name="name" style={{ width:"100%",margin:0,padding:0  }}>
              <AntInput placeholder="İsim" />
            </Form.Item>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", width: "100%" }}>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "50%",
      boxSizing: "border-box", // Eklenen box-sizing
      paddingTop:10,
    }}
  >
    <Form.Item label="Width:" name="width" style={{ width: "100%", margin: 0 }}>
      <AntInput placeholder="Width girin" />
    </Form.Item>
    <Form.Item label="Height:" name="height" style={{ width: "100%", marginTop: "10px",marginBottom:0}}>
      <AntInput placeholder="Height girin" />
    </Form.Item>
  </div>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "50%",
      boxSizing: "border-box", // Eklenen box-sizing
      paddingTop:10,

      paddingLeft:10
    }}
  >
    
              <Form.Item label="Renk" name="backgroundColor" style={{margin:0,width:"100%"}}>
            <ClearableSelect
              value={form4.getFieldValue('backgroundColor') || ''}
              onChange={(value) => form4.setFieldsValue({ backgroundColor: value })}
              options={colordsx.map((ilk) => ({
                value: ilk.code,
                label: ilk.text,
              }))}
              placeholder="Renk Seçin"
              form={form4}
              name="backgroundColor"
            />
          </Form.Item>
    <Form.Item label="A:" name="a" style={{ width: "100%", marginTop: "10px",marginBottom:0 }}>
      <AntInput placeholder="A" />
    </Form.Item>
  </div>

</div>

          <Form.Item label="Uzunkod:" name="kod" style={{ width: "50%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="kod" />
    </Form.Item>

    <Form.Item>
            <AntButton
              htmlType="submit"
              style={{
                width: '100%',
                marginTop: 10,
                backgroundColor: 'green',
                color: 'white',
                paddingTop: 15,
                paddingBottom: 15,
                fontSize: 15
              }}
            >
              Kaydet
            </AntButton>
          </Form.Item>
  

          <div style={{ width: '100%' }}>
          <div style={{ width: '100%',display:"flex",flexDirection:"row",justifyContent:"flex-end" }}>
          <Form.Item>
          <AntInput
  placeholder="Ara"
  value={searchText}
  onChange={(e) => handleSearchmini(e.target.value)}
  onSearch={(value) => handleSearchmini(value)} // `onSearch` direkt `handleSearchmini` fonksiyonunu alabilir
  style={{ marginBottom: '0',width:"100%"}}
/>
</Form.Item>
</div>

            <Table
              columns={minicolumnsgrafikdurum}
              dataSource={GrafDurum} // Tablo verisi GrafDurum state'inden gelir
              rowKey="code"
              pagination={{ pageSize: 4 }}
              onRow={(record) => ({
                onClick: () => handleRowGrafDurumClick(record),

              })}
              components={{
    body: {
      row: (props) => (
        <tr {...props} style={{ height: '30px' }} /> // Satır yüksekliği burada ayarlanır
      ),
    },
  }}
            />
<Modal
  title="Referans Güncelle"
  visible={isRowModalVisible}
  onOk={handleRowModalSave}
  onCancel={() => setIsRowModalVisible(false)}
  okText="Güncelle" // "OK" yerine "Güncelle"
  cancelText="İptal" // "Cancel" yerine "İptal"
>
<Form 
  layout="inline" // Daha iyi düzen için "vertical"
  style={{ gap: '10px' }} // Form genel boşluk
>
  {/* Kod ve İsim Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Kod"
      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.code || ""}
        onChange={(e) => handleRowModalChange("code", e.target.value)}
      />
    </Form.Item>
    <Form.Item
      label="İsim"
      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.name || ""}
        onChange={(e) => handleRowModalChange("name", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Genişlik ve Yükseklik Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Genişlik"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.width || ""}
        onChange={(e) => handleRowModalChange("width", e.target.value)}
      />
    </Form.Item>
    <Form.Item
      label="Yükseklik"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.height || ""}
        onChange={(e) => handleRowModalChange("height", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Renk ve A Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Renk"

      style={{ width:"50%" }}
    >
      <ClearableSelect
        value={selectedRowData?.backgroundColor || ''}
        onChange={(value) => handleRowModalChange("backgroundColor", value)}
        options={colordsx.map((ilk) => ({
          value: ilk.code,
          label: ilk.text,
        }))}
        placeholder="Renk Seçin"
      />
    </Form.Item>
    <Form.Item
      label="A"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.a || ""}
        onChange={(e) => handleRowModalChange("a", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Uzunkod */}
  <Form.Item 
    label="Uzunkod" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.kod || ""}
      onChange={(e) => handleRowModalChange("kod", e.target.value)}
    />
  </Form.Item>
</Form>

</Modal>

          </div>
       
        </Form>
      </div>
    )
  }
  const handleSaveOrder = () => {
    const errors = [];
    const priceLabelTransformed = isHome
    ? values.priceLabel.map((pl) => ({
        ...pl,
        mix: deriveMixFromSizes(pl),
      }))
    : values.priceLabel

    // ZaraHome ise validasyonu sizes[].mixed üzerinden türetilmiş mix ile yap
    console.log(brannd)
    if(!brannd === "ZaraHome"){

    priceLabelTransformed.forEach((item, index) => {
      console.log("itemitemitemitemitem",item)
      if (!item.mix?.[0]?.currency && !item.mix?.[1]?.currency) {
        errors.push(`Price Label ${index + 1}: Currency 1 ve Currency 2 alanlarının en az biri seçili olmalıdır.`);
      }
    });
  }
  priceLabelTransformed.forEach((item, index) => {
    if(!item.colorCode || !item.referanceCode)
    {
      errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
    }
  });
 

    const department = `${brand.split('_')[1]} / ${dept.split('_')[1]} / ${subDept}`
    const filteredValues = values.washingLabel.map((label) => {
      const filteredFabric = label.fabric.map((fabricItem) => {
        const filteredMix = fabricItem.mix.filter((mix) => mix.percent > 0)
        return { ...fabricItem, mix: filteredMix }
      })

      return { ...label, fabric: filteredFabric }
    })
    const path = `${brand}/${dept}/${subDept}`
    // ZaraHome ise payload içinde priceLabel'ı dönüştürülmüş mix ile gönder
    const payload = isHome
      ? { ...values, priceLabel: priceLabelTransformed, washingLabel: filteredValues, brand: brandId, department, path }
      : { ...values, washingLabel: filteredValues, brand: brandId, department, path }
    if(errors.length === 0)
    {
      saveOrder(payload)
    }
  }

  const hasDuplicateFabricTypes = () => {
    return values.washingLabel.some((label) => {
      const fabricTypes = label.fabric.flatMap((fabric) => fabric.mix.map((mix) => mix.type))
      const uniqueFabricTypes = new Set(fabricTypes)
      return uniqueFabricTypes.size !== fabricTypes.length
    })
  }

  const handleUpdateOrder = () => {
    const errors = [];
    const priceLabelTransformed = isHome
      ? values.priceLabel.map((pl) => ({
          ...pl,
          mix: deriveMixFromSizes(pl),
        }))
      : values.priceLabel

    if(!brannd === "ZaraHome"){
    priceLabelTransformed.forEach((item, index) => {
      if (!item.mix?.[0]?.currency && !item.mix?.[1]?.currency) {
        errors.push(`Price Label ${index + 1}: Currency 1 ve Currency 2 alanlarının en az biri seçili olmalıdır.`);
      }
    });
  }
  priceLabelTransformed.forEach((item, index) => {
    if(!item.colorCode || !item.referanceCode)
    {
      errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
    }
  });



    if (errors.length > 0) {
      // Hataları gösterme şeklinizi buraya yazın. Örneğin:
      toast.error(errors[0])
      return; // İşlemi durdur
    }
    if (!values.priceLabel[0]?.colorCode) {
      toast.error("Renk Kodu Girilmek Zorunda")
      return
    }
    // Tekrar eden kumaş türü yoksa, güncelleme işlemini gerçekleştir
    const filteredValues = values.washingLabel.map((label) => {
      const filteredFabric = label.fabric.map((fabricItem) => {
        const filteredMix = fabricItem.mix.filter((mix) => mix.percent > 0)
        return { ...fabricItem, mix: filteredMix }
      })

      return { ...label, fabric: filteredFabric }
    })
    delete values.brandId

    const body = isHome
      ? { ...values, priceLabel: priceLabelTransformed, washingLabel: filteredValues, brand: brandId }
      : { ...values, washingLabel: filteredValues, brand: brandId }
      if(errors.length === 0)
      {
    updateOrder({ id: orderNo, body })
    }
  }

  return (
    <FieldArray name="priceLabel">
      {({ push, remove }) => (
        <div>
          {values.priceLabel.map((_, idx) => {
            // map fonksiyonu gövdesinde normal JS yazabiliriz
            const Show5290DUVET = !!(
              values?.priceLabel?.[idx]?.referanceCode === '68c8aac52e0a8308a3c61eb5' ||
              values?.priceLabel?.[idx]?.referanceCode === '68d73fd228a54263b9295918' ||
              values?.priceLabel?.[idx]?.referanceCode === '68e1183ac95569b4b9b19e23' ||
              values?.priceLabel?.[idx]?.referanceCode === '68e5c73619c6f6a55ea0356a'
            );
  
            return (
              <div
                className="grid grid-cols-2 gap-5 pb-5 relative"
                key={idx}
              >
                {/* ÜST BLOK */}
                <div className="col-span-2 grid grid-cols-2 gap-2 rounded border border-dashed p-2">
                  <NoFormInput
                    label="Müşteri Sipariş No"
                    value={values.priceLabel[idx]?.customerOrderNo}
                    onChange={(e) => {
                      if (values.changesForEveryProduct) {
                        setFieldValue(
                          `priceLabel[${idx}].customerOrderNo`,
                          e.target.value
                        );
                      }
                    }}
                  />
  
                  <Input
                    label="Müşteri Sipariş Detayı"
                    name={`priceLabel[${idx}].customerOrderDetail`}
                    autoComplete="off"
                  />
  
                  <Input
                    label="Renk Kodu"
                    name={`priceLabel[${idx}].colorCode`}
                    maxLength="3"
                    autoComplete="off"
                  />
  
                  {/* Referans Code ve Modal Açma Alanı */}
                  <DisliSayisiDetayModal
                    visible={isDisliModalVisible}
                    onCancel={handleDisliModalClose}
                    minWidth={'30%'} // modalType 4 ise minWidth 40%, aksi halde 30%
                    width={740}
                    title="Fiyat Etiketi Referans Ekle"
                  >
                    <DrawerContent4 />
                  </DisliSayisiDetayModal>
  
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      width: '100%',
                    }}
                  >
                    <div style={{ width: '60%' }}>
                      {/* Sadece ilk indexte Referance select görünsün */}
                      <div className={idx > 0 ? 'hidden' : ''}>
                        <SelectReferanceCode3
                          name={`priceLabel[${idx}].referanceCode`}
                          brannd={brannd}
                          typee={deptName}
                        />
                      </div>
                    </div>
  
                    {/* Referans Ekle Butonu (ADMIN + doğru firma) */}
                    {user.companyName ===
                      'Şimşek Ege Etiket ve Matbaacılık\nLimited Şirketi' &&
                      user.tierType === 'ADMIN' && (
                        <div
                          style={{
                            width: '20%',
                            overflow: 'hidden',
                            marginRight: 0,
                          }}
                        >
                          <UIButton
                            type="button"
                            variant="blue"
                            onClick={handleDisliModalOpen}
                            style={{ width: '100%' }}
                          >
                            Referans Ekle
                          </UIButton>
                        </div>
                      )}
  
                    {/* OTO DOLDUR butonu */}
                    <div style={{ width: '20%' }}>
                      {(values.washingLabel?.some(label => label?.sizes?.length > 0) ||
                        values.beltLabel?.some(label => label?.sizes?.length > 0) ||
                        values.brandLabel?.some(label => label?.sizes?.length > 0) ||
                        values.zaraHomeLabel11?.some(label => label?.sizes?.length > 0) ||
                        values.zaraHomeLabel12?.some(label => label?.sizes?.length > 0)) && (
                        <UIButton
                          type="button"
                          style={{ backgroundColor: '#b0059c' }}
                          onClick={() => {
                            const availableLabels = [];
                            
                            // Her kaynak tipindeki her colorCode için ayrı seçenek oluştur
                            if (values.washingLabel?.some(label => label?.sizes?.length > 0)) {
                              const washingLabels = values.washingLabel.filter(label => label?.sizes?.length > 0);
                              washingLabels.forEach((label, idx) => {
                                availableLabels.push({
                                  type: 'washing',
                                  label: label,
                                  name: washingLabels.length > 1 ? `Yıkama Talimatı - ${label.colorCode || `Renk ${idx + 1}`}` : 'Yıkama Talimatı',
                                  colorCode: label.colorCode || ''
                                });
                              });
                            }
                            
                            if (values.beltLabel?.some(label => label?.sizes?.length > 0)) {
                              const beltLabels = values.beltLabel.filter(label => label?.sizes?.length > 0);
                              beltLabels.forEach((label, idx) => {
                                availableLabels.push({
                                  type: 'belt',
                                  label: label,
                                  name: beltLabels.length > 1 ? `Kemer Etiketi - ${label.colorCode || `Renk ${idx + 1}`}` : 'Kemer Etiketi',
                                  colorCode: label.colorCode || ''
                                });
                              });
                            }
                            
                            if (values.brandLabel?.some(label => label?.sizes?.length > 0)) {
                              const brandLabels = values.brandLabel.filter(label => label?.sizes?.length > 0);
                              brandLabels.forEach((label, idx) => {
                                availableLabels.push({
                                  type: 'brand',
                                  label: label,
                                  name: brandLabels.length > 1 ? `Marka Kartı - ${label.colorCode || `Renk ${idx + 1}`}` : 'Marka Kartı',
                                  colorCode: label.colorCode || ''
                                });
                              });
                            }
                            
                            if (values.zaraHomeLabel11?.some(label => label?.sizes?.length > 0)) {
                              const zara11Labels = values.zaraHomeLabel11.filter(label => label?.sizes?.length > 0);
                              zara11Labels.forEach((label, idx) => {
                                availableLabels.push({
                                  type: 'zaraHomeLabel11',
                                  label: label,
                                  name: zara11Labels.length > 1 ? `Label 11 - ${label.colorCode || `Renk ${idx + 1}`}` : 'Label 11',
                                  colorCode: label.colorCode || ''
                                });
                              });
                            }
                            
                            if (values.zaraHomeLabel12?.some(label => label?.sizes?.length > 0)) {
                              const zara12Labels = values.zaraHomeLabel12.filter(label => label?.sizes?.length > 0);
                              zara12Labels.forEach((label, idx) => {
                                availableLabels.push({
                                  type: 'zaraHomeLabel12',
                                  label: label,
                                  name: zara12Labels.length > 1 ? `Label 12 - ${label.colorCode || `Renk ${idx + 1}`}` : 'Label 12',
                                  colorCode: label.colorCode || ''
                                });
                              });
                            }
  
                            if (availableLabels.length > 0) {
                              let selectedIndex = null;

                              // Tek seçenek varsa direkt kopyala
                              if (availableLabels.length === 1) {
                                const selectedItem = availableLabels[0];
                                setFieldValue(`priceLabel[${idx}]`, {
                                  ...values.priceLabel[idx],
                                  sizeDefectivePercent: selectedItem.label.sizeDefectivePercent || '',
                                  sizes: selectedItem.label.sizes.map((size) => ({
                                    ...size,
                                    amount: size.amount || '',
                                    amountWithDefect: size.amountWithDefect || '',
                                  })),
                                });
                                message.success(
                                  `${selectedItem.name}${selectedItem.colorCode ? ' - ' + selectedItem.colorCode : ''} bedenleri kopyalandı`
                                );
                              } else {
                                // Birden fazla seçenek varsa modal göster
                                Modal.confirm({
                                  title: 'Veri Kaynağını Seçin',
                                  content: (
                                    <Select
                                      style={{ width: '100%' }}
                                      placeholder="Kaynak seçin"
                                      onChange={(value) => {
                                        selectedIndex = value;
                                      }}
                                    >
                                      {availableLabels.map((item, itemIdx) => (
                                        <Select.Option key={itemIdx} value={itemIdx}>
                                          {item.name}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  ),
                                  onOk: () => {
                                    if (selectedIndex === null) {
                                      message.error('Lütfen bir kaynak seçin');
                                      return;
                                    }
                                    
                                    const selectedItem = availableLabels[selectedIndex];
                                    if (selectedItem && selectedItem.label) {
                                      setFieldValue(`priceLabel[${idx}]`, {
                                        ...values.priceLabel[idx],
                                        sizeDefectivePercent: selectedItem.label.sizeDefectivePercent || '',
                                        sizes: selectedItem.label.sizes.map((size) => ({
                                          ...size,
                                          amount: size.amount || '',
                                          amountWithDefect: size.amountWithDefect || '',
                                        })),
                                      });
                                      message.success(
                                        `${selectedItem.name}${selectedItem.colorCode ? ' - ' + selectedItem.colorCode : ''} bedenleri kopyalandı`
                                      );
                                    }
                                  },
                                });
                              }
                            } else {
                              message.warning('Kopyalanacak veri bulunamadı');
                            }
                          }}
                          className="w-full"
                        >
                          Oto Doldur
                        </UIButton>
                      )}
                    </div>
                  </div>
                </div>
  
                {/* ZaraHome ise özel blok */}
                {brannd === 'ZaraHome' ? (
  <div style={{ width: Show5290DUVET ? '200%' : '100%' }} className="w-full flex gap-4">
    {/* Left: PriceSectionHome */}
    <div className="flex-1">
      <PriceSectionHome
        idx={idx}
        setdepartmantIDD=""
        setifinch=""
        ifinch=""
      />
    </div>

    {/* Right: Symbol (opsiyonel) */}
    {Show5290DUVET && (
      <div className="flex-1">
        <Symbol idx={idx} index="2" brrand={brannd} />
      </div>
    )}
  </div>
) : null}

  
                {/* BEDENLER + FİYAT SECTİON GRID */}
                <div
                  className={`col-span-2 grid ${
                    brannd === 'ZaraHome'
                      ? 'grid-cols-1'
                      : 'grid-cols-[1fr_1fr]'
                  } gap-x-5`}
                >
                  {brannd === 'ZaraHome' ? (
                    <PriceSizesHome
                      setHomeProducts={setHomeProducts}
                      homeProducts={homeProducts}
                      idx={idx}
                      setdepartmantIDD={setdepartmantIDD}
                      setifinch={setifinch}
                      ifinch={ifinch}
                      brrand={brannd}
                    />
                  ) : (
                    <PriceSizes idx={idx} />
                  )}
  
                  {brannd === 'ZaraHome' ? null : (
                    <PriceSection idx={idx} />
                  )}
                </div>
  
                {/* AYIRICI + RENK SİL BUTONU */}
                <Separator className="col-span-2 h-[5px] bg-simsek" />
  
                {idx > 0 && (
                  <Button
                    variant="destructive"
                    onClick={() => remove(idx)}
                    className="absolute -right-40 top-0"
                  >
                    <X className="w-4 h-4 text-white" />
                    Renk Sil
                  </Button>
                )}
              </div>
            );
          })}
  
          {/* ALT BUTONLAR */}
          <div className="flex items-center gap-x-5">
            {!orderNo && (
              <Button
                type="submit"
                variant="softgreen"
                onClick={handleSaveOrder}
                disabled={isPending}
                className="w-full"
              >
                {isPending && (
                  <RotateCcw className="animate-spin mr-2" size={16} />
                )}
                Kaydet
              </Button>
            )}
  
            <Button
              type="button"
              onClick={orderNo ? handleUpdateOrder : handleSaveOrder}
              disabled={isPending || isPendingUpdate}
              className="w-full"
              variant={orderNo && 'softgreen'}
            >
              {(isPending || isPendingUpdate) && (
                <RotateCcw className="animate-spin mr-2" size={16} />
              )}
              {orderNo ? 'Güncelle' : "Artwork'e Git"}
            </Button>
  
            {orderNo && (
              <Link
                to={`/siparisler/artwork/${orderNo}?tab=${2}&zaratype=${brannd}`}
                target="_blank"
                className="w-full"
              >
                <Button
                  type="button"
                  disabled={isPending}
                  className="w-full"
                >
                  {isPending && (
                    <RotateCcw
                      className="animate-spin mr-2"
                      size={16}
                    />
                  )}
                  Artwork'e Git
                </Button>
              </Link>
            )}
  
            <Button
              type="button"
              disabled={isPending}
              className="w-full"
              style={{ backgroundColor: '#f56020', color: 'white' }}
              onClick={handleBicakIziModalOpen}
            >
              {isPending && (
                <RotateCcw className="animate-spin mr-2" size={16} />
              )}
              Bıçak İzi Hazırla
            </Button>
  
            <Button
              type="button"
              variant="blue"
              onClick={() => {
                push({
                  ...values.priceLabel[0],
                  colorCode: '',
                  sizeDefectivePercent: '',
                  sizes: values.priceLabel[0].sizes.map((size) => ({
                    ...size,
                    amount: '',
                    amountWithDefect: '',
                  })),
                });
              }}
              className="w-full"
            >
              Renk Ekle
            </Button>
          </div>
  
          {/* Bıçak İzi Modal */}
          <DisliSayisiDetayModal
            visible={isBicakIziModalVisible}
            onCancel={handleBicakIziModalClose}
            minWidth={'30%'}
            width={500}
            title={`Bıçak İzi Hazırla - Renk Kodu: ${
              values.priceLabel[0]?.colorCode || 'Belirtilmemiş'
            }`}
          >
            <div style={{ padding: '20px' }}>
              <h3 className="text-lg font-semibold mb-2">
                Beden Adetleri
              </h3>
              <p className="text-sm mb-4">
                Bıçak izi için seçtiğiniz bedenler ve adetleri belirleyin.
              </p>
  
              <div className="flex justify-between items-center mb-4 p-3 bg-gray-100 rounded-md border">
                <span className="font-semibold">
                  Toplam Bıçak İzi Adedi:
                </span>
                <span
                  className={`text-lg font-bold ${
                    totalAmount === mottoTake
                      ? 'text-green-600'
                      : totalAmount > 0
                      ? 'text-blue-600'
                      : 'text-gray-500'
                  }`}
                >
                  {totalAmount} / {mottoTake}
                </span>
              </div>
  
              {values.priceLabel[0]?.sizes.filter(
                (size) =>
                  size.amount &&
                  size.amount !== '0' &&
                  size.amount !== 0
              ).length === 0 ? (
                <div className="p-4 bg-yellow-50 rounded-md border border-yellow-200 text-center">
                  <p className="text-yellow-600">
                    Hiç beden seçilmemiş. Lütfen önce beden adetleri
                    girin.
                  </p>
                </div>
              ) : (
                <div className="border rounded-md p-4 mb-4 max-h-[300px] overflow-y-auto">
                  {values.priceLabel[0]?.sizes
                    .filter(
                      (size) =>
                        size.amount &&
                        size.amount !== '0' &&
                        size.amount !== 0
                    )
                    .map((size, sizeIdx) => (
                      <div
                        key={sizeIdx}
                        className="flex justify-between items-center mb-3 border-b pb-2"
                      >
                        <div className="flex flex-col">
                          <span className="text-md font-medium">
                            {size.sizeCode}
                          </span>
                          <span className="text-xs text-gray-500">
                            {size.sizeName ||
                              size.name ||
                              'Beden'}
                          </span>
                        </div>
  
                        <div className="flex items-center">
                          <input
                            type="number"
                            min="0"
                            max={mottoTake}
                            value={
                              sizeAmounts[
                                `${size.sCode}_${
                                  size.name || 'Beden'
                                }`
                              ] || 0
                            }
                            onChange={(e) =>
                              handleSizeAmountChange(
                                size.sCode,
                                size.name || 'Beden',
                                e.target.value
                              )
                            }
                            className="border rounded-md px-3 py-2 w-[100px] text-right"
                            onFocus={(e) => e.target.select()}
                          />
                          <span className="ml-2">Adet</span>
                        </div>
                      </div>
                    ))}
                </div>
              )}
  
              <div className="flex justify-end mt-6">
                <Link
                  to={createBicakIziUrl()}
                  className="w-full"
                  onClick={(e) => {
                    // Eğer hiç beden yoksa engelle
                    if (totalAmount === 0) {
                      e.preventDefault();
                    } else {
                      handleBicakIziBas();
                    }
                  }}
                >
                  <Button
                    disabled={totalAmount === 0}
                    className="w-full"
                    style={{
                      backgroundColor: '#f56020',
                      color: 'white',
                    }}
                  >
                    Bıçak İzi Bas
                  </Button>
                </Link>
              </div>
            </div>
          </DisliSayisiDetayModal>
        </div>
      )}
    </FieldArray>
  );
  
}
